import styled from 'styled-components';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { Select } from 'antd';

import ic_chevron_check_black from 'asserts/icons/ic_chevron_check_black.svg';
import { ReactComponent as IconArrow } from 'asserts/icons/ic_chevron_down_select.svg';

interface DefaultSelectMenuProps {
  options: any;
  width?: string;
  value?: string | number;
  placeholder?: string;
  defaultValue?: string;
  size?: 'large' | 'medium' | 'small';
  onChange: (data: string | number) => void;
}

const DefaultSelectMenu = ({
  placeholder,
  options,
  width,
  value,
  defaultValue,
  size,
  onChange
}: DefaultSelectMenuProps) => {
  return (
    <Wrapper $size={size}>
      <Select
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        suffixIcon={<IconArrow />}
        onChange={onChange}
        options={options}
        optionRender={(option) => (
          <Item>
            {value === option.data.value && <img src={ic_chevron_check_black} alt="체크 아이콘" />}
            <span role="img" aria-label={option.data.label}>
              {option.data.label}
            </span>
          </Item>
        )}
      />
    </Wrapper>
  );
};

export default DefaultSelectMenu;

const Wrapper = styled.div<{ $size?: string }>`
  svg {
    width: 16px;
    height: 16px;
  }

  .ant-select {
    height: ${(props) =>
      props.$size === 'large' ? '44px' : props.$size === 'medium' ? '36px' : '32px'};

    &:hover .ant-select-selector {
      background-color: #fff;
      box-shadow: none;
      border-color: #c5c5c5 !important;
    }
    &.ant-select-focused .ant-select-selector,
    &:focus-within,
    &.ant-select-open {
      border-color: ${color.black2} !important;
      box-shadow: none !important;
      outline: none;
    }
  }
  .ant-select.ant-select-open .ant-select-arrow {
    transform: rotate(180deg);
  }
  .ant-select-selection-item {
    ${(props) =>
      props.$size === 'large'
        ? font.body_regular
        : props.$size === 'medium'
        ? font.caption1_regular
        : font.caption2_regular};
  }

  .ant-select-selector .ant-select-selection-placeholder {
    ${(props) =>
      props.$size === 'large'
        ? font.body_regular
        : props.$size === 'medium'
        ? font.caption1_regular
        : font.caption2_regular};
  }
`;

const Item = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  height: 100%;
  gap: 8px;
  img {
    width: 16px;
    height: 100%;
  }
  span {
    ${font.body_regular};
  }
`;
